import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { CheckCircleOutline, RemoveCircleOutline } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import Tag from '../Tag.jsx';
import { getColorFromThemeName } from '../../_config/utils.js';
import { GREEN, TABLE_HEADER_COLOR, VIRTUAL_INTERCOM_EXTENSION_VISIBILITY } from '../../_config/consts.js';
import VisibilityVisibleIconCustom from '../CustomIcons/VisibilityVisibleIconCustom.jsx';
import VisibilityInvisibleIconCustom from '../CustomIcons/VisibilityInvisibleIconCustom.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  extensionRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'white',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -5,
    width: 'max-content',
  },
  usersContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: -5,
  },
  groupTag: {
    backgroundColor: '#e0e0e0',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
  },
  lockRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 5
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, intercom: state.intercom, themeName: state.settings.items.theme.data.themeName }))
class ExtensionTableView extends React.Component {
  render() {
    const {
      classes,
      viewLoading,
      themeName,
      onDeleteExtension,
      onNewExtension,
      intercom: { selectedExtension, extensions: { content: extensionData, pagination: { number: currentPage, size, totalPages, totalElements }, filters }},
      onSelectExtension,
      onRefreshExtensions,
      onFetchExtensionsOnPage,
    } = this.props;
    const headerColor = getColorFromThemeName(themeName);
    const filtersActive = Boolean(filters && (filters.name || filters.groupId));
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(extensionData) ? (
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="extensions" /></h3>
                        <IconButton onClick={() => onRefreshExtensions()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="extensionsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchExtensionsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchExtensionsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="extensionId" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="name" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="extensionGroup" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="extensionUsers" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="extensionVisibility" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(extensionData, (extension) => (
                    <TableRow
                      key={extension.id}
                      className={classes.row}
                      hover
                      classes={{
                        selected: classes.rowSelected,
                        hover: classes.rowHovered,
                      }}
                      onClick={event => onSelectExtension(extension)}
                      selected={selectedExtension && selectedExtension.id === extension.id}
                    >
                      <TableCell>
                        <div className={classes.extensionRowContainer}>
                          <h5 style={{ fontSize: 16 }}>{extension.id}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.extensionRowContainer}>
                          <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{extension.name}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.extensionRowContainer}>
                          <div className="resourceInfoRow-typeTag-flat">
                            <h5 style={{ color: 'white', margin: 0 }}>{extension.group?.name}</h5>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.usersContainer}>
                          {_.map(_.sortBy(extension.users, 'id'), user => (
                            <Tag
                              key={user.user.id}
                              tag={{type:'user', name: `${user.user.username}`, color: '#ba68c8'}}
                            />
                          ))}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.lockRowContainer}>
                          <h5 style={{ color: extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? GREEN : 'grey', marginRight: 10 }}> 
                            <Entity key={extension.visibility} entity={extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? 'extensionVisibilityVisible' : 'extensionVisibilityHidden'} /></h5>
                          {extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? (
                            <VisibilityVisibleIconCustom style={{ width: 20, color: GREEN }} />
                          ) : <VisibilityInvisibleIconCustom style={{ width: 20, color: 'grey' }} />}
                        </div>
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={(event) => {
                            event.stopPropagation();
                            onDeleteExtension(extension.id);
                          }}
                          className={classes.button}
                        >
                          <Entity entity="delete" />
                          <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="extensionsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchExtensionsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchExtensionsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
          ) : (
            <div>
              {!viewLoading ? (
                <EmptyView
                  title={!filtersActive ? 'noExtensions' : 'noExtensionsFound'}
                  subtitle={!filtersActive ? 'noExtensionsDescription' : 'noExtensionsFoundDescription'}
                  onNewEntity={!filtersActive && onNewExtension ? () => onNewExtension() : null}
                  newEntityTitle="createNewF"
                />
              ) : (
                <ListLoadingView />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ExtensionTableView); 